import ParameterFieldBase, { IParameterFieldBaseOptions } from './ParameterFieldBase';
import EditComponent from '../tsx/DiscreteMappingField';

export class DiscreteMappingField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static defaultValidators = [];

    public static EditComponent = EditComponent;

    public static getDefaultValue() {
        return [];
    }

    constructor(glob, title: string, validators?: any, defaultVal?: any, options?) {
        if (defaultVal == null) {
            defaultVal = DiscreteMappingField.getDefaultValue();
        }

        super(glob, title, DiscreteMappingField.defaultValidators, validators, defaultVal, options);
    }
}
